import { Component, Input, ViewChild } from '@angular/core';

import {
  ApexAxisChartSeries,
  ApexTitleSubtitle,
  ApexDataLabels,
  ApexChart,
  ApexPlotOptions,
  ApexLegend,
} from 'ng-apexcharts';
import { DataService } from 'src/app/services/data.service';

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  title: ApexTitleSubtitle;
  plotOptions: ApexPlotOptions;
  legend: ApexLegend;
  colors: string[];
};

@Component({
  selector: 'app-tree-map',
  templateUrl: './tree-map.component.html',
  styleUrls: ['./tree-map.component.scss'],
})
export class TreeMapComponent {
  @Input() data: any;

  colors = ['#F7517F', '#6648FF', '#703D94', '#FACB7D', '#3F4357', '#16CEB9'];
  chartOptions: any = {
    series: [
      {
        data: [{ x: 'Loading', y: 1 }],
      },
    ],

    chart: {
      toolbar: {
        show: false,
      },
      height: 450,
      type: 'treemap',
      fontFamily: 'SSTArabicBold',
    },
    title: {
      text: 'Loading',
      align: 'center',
    },
    colors: this.colors,
    fill: {
      opacity: 1,
    },
    tooltip: {
      style: {
        fontSize: '14px',
        fontFamily: 'SSTArabicBold',
        color: '#000', // Set hover text color to black
      },
    },
  };
  date_added: boolean = false;

  graphData: any;
  startDate: Date = new Date('09-09-2023');
  endDate: Date = new Date();
  today: Date = new Date();
  limit: number = 10;

  constructor(private dataService: DataService) {}

  async ngOnInit() {
    this.graphData = await this.getDataFromArg(
      this.startDate,
      this.endDate,
      this.limit
    );

    this.chartOptions = this.generateChart(this.data.graphname, this.graphData);
  }

  async getDataFromArg(startDate?: Date, endDate?: Date, limit: number = 10) {
    // let res = await this.dataService.postData(
    //   'dashboards/dynamic-aggregation',
    //   {
    //     aggregation: this.data.aggregation,
    //     tableName: this.data.table,
    //     timeRange:
    //       startDate && endDate
    //         ? { startDate: startDate, endDate: endDate }
    //         : null,
    //     limit: limit,
    //   }
    // );

    // return res.data;

    let managerOu: any = localStorage.getItem('managerOus');

    managerOu = managerOu ? JSON.parse(managerOu) : null;

    if (this.data.tag && this.data.tag === 'MANAGER' && managerOu && managerOu.length > 0) {
      let res = await this.dataService.postData(
        'dashboards/dynamic-aggregation',
        {
          aggregation: this.data.aggregation,
          tableName: this.data.table,
          timeRange: (startDate && endDate) ? { startDate: startDate, endDate: endDate } : null,
          managerOus: managerOu,
          pre_arg: this.data.pre_arg ? this.data.pre_arg : null,
          limit: limit
        }
      );
      return res.data;
    } else {
      let res = await this.dataService.postData(
        'dashboards/dynamic-aggregation',
        {
          aggregation: this.data.aggregation,
          tableName: this.data.table,
          timeRange:  (startDate && endDate) ? { startDate: startDate, endDate: endDate } : null,
          pre_arg: this.data.pre_arg ? this.data.pre_arg : null,
          limit: limit
        }
      );
      return res.data;
    }
  }

  async onLimitChange() {
    this.graphData = await this.getDataFromArg(
      this.startDate,
      this.endDate,
      this.limit
    );
    this.chartOptions = this.generateChart(this.data.graphname, this.graphData);
  }

  async onDateChange() {
    // Ensure startDate is not greater than endDate
    if (this.startDate && this.endDate && this.startDate > this.endDate) {
      this.endDate = this.startDate;
    }

    this.graphData = await this.getDataFromArg(
      this.startDate,
      this.endDate,
      this.limit
    );

    this.chartOptions = this.generateChart(this.data.graphname, this.graphData);
  }

  generateChart(title: any, dataset: { key: string; count: number }[]): any {
    var data = dataset.map((item: { key: string; count: number }) => {
      return { x: item.key, y: item.count };
    });

    console.log(data);

    var chart = {
      series: [
        {
          data: data,
        },
      ],

      chart: {
        toolbar: {
          show: false,
        },
        height: 450,
        type: 'treemap',
        fontFamily: 'SSTArabic',
      },
      title: {
        text: title,
        align: 'center',
      },
      colors: this.colors,
      fill: {
        opacity: 1,
      },
    };

    return chart;
  }
}
